import { render, staticRenderFns } from "./LabelNormal.vue?vue&type=template&id=2f07cebe&scoped=true&"
import script from "./LabelNormal.vue?vue&type=script&lang=js&"
export * from "./LabelNormal.vue?vue&type=script&lang=js&"
import style0 from "./LabelNormal.vue?vue&type=style&index=0&id=2f07cebe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f07cebe",
  null
  
)

export default component.exports